var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockSlateBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 1C5.43141 1 0.945312 5.4861 0.945312 11C0.945312 16.5139 5.43141 21 10.9453 21C16.4592 21 20.9453 16.5139 20.9453 11C20.9453 5.4861 16.4592 1 10.9453 1ZM10.9453 19.75C6.12048 19.75 2.19532 15.8248 2.19532 11C2.19532 6.17517 6.12048 2.25001 10.9453 2.25001C15.7701 2.25001 19.6953 6.17517 19.6953 11C19.6953 15.8248 15.7701 19.75 10.9453 19.75Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 4.75H10.3203V11.2588L14.2534 15.1919L15.1372 14.3081L11.5703 10.7412V4.75Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSlateBlue);
export default __webpack_public_path__ + "static/media/clock-slate-blue.b01ad2999160cddf8b37cbd24913f88d.svg";
export { ForwardRef as ReactComponent };